module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjMiIGhlaWdodD0iMTIzIiB2aWV3Qm94PSIwIDAgMTIzIDEyMyI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxyZWN0IHdpZHRoPSIxMjMiIGhlaWdodD0iMTIzIiBmaWxsPSIjRDAwMjFCIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHJ4PSI0Ii8+CiAgICAgICAgPGcgc3Ryb2tlPSIjRkZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iOCI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik00MC4zNDQgODMuNjRMODMuNjQgNDAuMzQ0TTgzLjY0IDgzLjY0TDQwLjM0NCA0MC4zNDQiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/answer-no-selected.svg
// module id = 462
// module chunks = 0